<template>
  <div class="row mb-3">
    <div class="col">
      <button
        class="btn btn-primary me-3"
        type="button"
        @click="
          $router.push({
            name: 'ServiceOrder',
            params: { workOrderId: 'new', facilityID: filters.facility, customerID: filters.customer },
          })
        "
        v-show="$hasRoleStartsWith(role, ['Administrator', 'Leader', 'Worker'])"
      >
        Nov servisni nalog
      </button>
      <button
        class="btn btn-info me-3"
        type="button"
        @click="$router.push({ name: 'InternalOrder', params: { workOrderId: 'new' } })"
        v-show="$hasRoleStartsWith(role, ['Administrator', 'Leader', 'Worker'])"
      >
        Nov interni nalog
      </button>
      <button
        class="btn btn-link"
        type="button"
        @click="$router.push({ name: 'ServiceOrdersMap' })"
        v-show="$hasRoleStartsWith(role, ['Administrator', 'Leader', 'Worker'])"
      >
        Zemljevid 🚩 aktivnih servisnih nalogov
      </button>
      <button
        class="btn btn-link"
        type="button"
        @click="downloadAttachmentsAsync('pdf')"
        :disabled="!orders?.length"
        v-show="$hasRoleStartsWith(role, ['Administrator', 'Leader'])"
      >
        Prenesi PDF priloge
      </button>
      <button
        class="btn btn-link"
        type="button"
        @click="downloadAttachmentsAsync('leak')"
        :disabled="!orders?.length"
        v-show="$hasRoleStartsWith(role, ['Administrator', 'Leader'])"
      >
        Prenesi preskuse
      </button>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-8">
      <div
        class="row mb-2 filter-customer-entity"
        v-if="$hasRoleStartsWith(role, ['Administrator', 'Leader', 'Worker', 'Worker'])"
      >
        <div class="col-md-6">
          <SelectCustomerEntity
            col-class-left="col-sm-3"
            col-class-right="col-sm-9"
            :customerID="filters.customer"
            :facilityID="filters.facility"
            :canChange="true"
            @change="
              (e) => {
                filters.customer = e.customerID
                filters.facility = e.facilityID
              }
            "
          />
        </div>
      </div>
      <div class="row mb-2 filter-customer-entity" v-else-if="$hasRoleStartsWith(role, ['Customer'])">
        <div class="col-md-6">
          <SelectCustomerEntity
            col-class-left="col-sm-3"
            col-class-right="col-sm-9"
            :customerID="currentCustomerId"
            :facilityID="filters.facility"
            :canChangeCustomer="false"
            :canChange="true"
            @change="
              (e) => {
                filters.customer = currentCustomerId
                filters.facility = e.facilityID
              }
            "
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6" v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker'])">
          <div class="row">
            <label class="col-form-label col-sm-3">Delavec</label>
            <div class="col-sm-9">
              <SelectEntity apiEntity="DropDown/Workers" v-model="filters.ownerID" />
            </div>
          </div>
        </div>
        <div class="col-md-6" v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker'])">
          <div class="row">
            <label class="col-form-label col-sm-3">Odprl</label>
            <div class="col-sm-9">
              <SelectEntity apiEntity="InternalUsers" v-model="filters.userCreated" />
              <!--TODO-->
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6">
          <div class="row">
            <label class="col-form-label col-sm-3">Št. naloga</label>
            <div class="col-sm-9">
              <input class="form-control" type="text" v-model.lazy="filters.orderNumber" />
            </div>
          </div>
        </div>
        <div class="col-md-6" v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker'])">
          <div class="row">
            <label class="col-form-label col-sm-3">Material</label>
            <div class="col-sm-9">
              <div class="input-group">
                <SearchMaterial @selected="(e) => (filters.materialID = e.id)" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <DateTimeFilterSet v-model="filters" />

      <div class="row mb-2">
        <div class="row">
          <div class="col-sm-2">Prioriteta:</div>
          <div class="col">
            <IntegerRadioGroup v-model="filters.priority" :numberOfValues="3" />
          </div>
        </div>
        <div class="col-md-6" v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker'])">
          <BoolFilter label="Posebnosti" name="isSpecial" v-model="filters.isSpecial" />
          <BoolFilter label="Pozornost" name="isAttention" v-model="filters.isAttention" />
          <BoolFilter label="Garancija" name="warranty" v-model="filters.isWarranty" />
          <BoolFilter label="Potrjen" name="isAccepted" v-model="filters.isAccepted" />
          <BoolFilter label="Delni kom." name="hadUncompletedCommission" v-model="filters.hadUncompletedCommission" />
          <BoolFilter label="Avtom. razdalja" name="distanceAssignment" v-model="filters.isDistanceAssignment" />
          <BoolFilter label="Del periodike" name="isGeneratedPeriodic" v-model="filters.isGeneratedPeriodic" />
          <BoolFilter label="Datum obiska" name="hasDatePlannedVisit" v-model="filters.hasDatePlannedVisit" />
        </div>
        <div class="col-md-6">
          <div class="row">
            <PeriodicsFilter :filters="filters" />
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-12">
          <div class="row">
            <label class="col-form-label col-sm-3">Zadeva, opis,..</label>
            <div class="col-sm-9">
              <input class="form-control" v-model.lazy="filters.searchTerm" />
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-2" v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker'])">
        <div class="col-md-12">
          <div class="row">
            <label class="col-form-label col-sm-3">Veza na projekt</label>
            <div class="col-sm-9">
              <SelectEntity apiEntity="DropDown/Projects?status=1" v-model="filters.projectID" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <SelectStatus
        :statuses="statuses"
        v-model="filters.status"
        @change="$toggleMultiSelect(filters, 'status', $event)"
        :multiple="true"
      />
      <div class="row mt-2">
        <div class="col"><a class="btn btn-sm btn-secondary" @click="resetFilters">Pobriši iskalne pogoje</a></div>
      </div>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col">
      <div class="table-responsive">
        <table class="table table-stripped table-sm table-hover">
          <thead>
            <tr>
              <th scope="col" class="text-nowrap" v-show="$hasRoleStartsWith(role, ['Administrator', 'Leader'])">
                Z izbranimi
              </th>
              <th scope="col" class="text-nowrap bg-light">Številka naloga</th>
              <th class="d-none d-lg-table-cell bg-light">Status</th>
              <th scope="col">Št.kom.</th>
              <th scope="col">Zadeva</th>
              <th class="d-none d-lg-table-cell" scope="col">Stranka</th>
              <th scope="col">Objekt</th>
              <th scope="col">Delavec</th>
            </tr>
          </thead>
          <tbody>
            <tr role="button" v-for="order in orders">
              <td v-show="$hasRoleStartsWith(role, ['Administrator', 'Leader'])">
                <input type="checkbox" v-model="order.selected" />
              </td>
              <td @click="selectOrderAsync(order, true)" class="bg-light">
                <span class="badge bg-danger me-1" v-show="order.priority === 1">1</span>
                <span class="badge bg-warning me-1" v-show="order.priority === 2">2</span>
                <span class="badge bg-info me-1" v-show="order.priority === 3">3</span>

                {{ order.orderNumber }}
                <OrderBadge cssClass="d-block d-lg-none" :workOrder="order" />
              </td>
              <td @click="selectOrderAsync(order, true)" class="bg-light d-none d-lg-table-cell">
                <OrderBadge :workOrder="order" />
              </td>
              <td @click="selectOrderAsync(order)">
                {{ order.commissions }}
                <span v-show="order.hadUncompletedCommission" class="badge bg-warning text-dark">Delni komision!</span>
              </td>
              <td @click="selectOrderAsync(order)">
                {{ order.subject }}
                <!-- TODO duplicate -->
                <OrderIsBadge :workOrder="order" />
              </td>
              <td @click="selectOrderAsync(order)" class="d-none d-lg-table-cell">{{ order.customerName }}</td>
              <td @click="selectOrderAsync(order)">{{ order.facilityName }}</td>
              <td @click="selectOrderAsync(order)">
                {{ order.owner }}
                <button
                  class="btn btn-sm btn-outline-secondary"
                  type="button"
                  v-if="isAdmin && !order.owner?.trim()"
                  @click.stop="orderToAssign = order"
                >
                  Dodeli
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <ModalAssignWorkOrderSimple
    :visible="!!orderToAssign"
    :orderForAssignment="orderToAssign"
    @close="orderToAssign = null"
    @assigned="onAssigned"
  />
  <div class="row mt-5" v-show="$hasRoleStartsWith(role, ['Administrator', 'Leader'])">
    <div class="col">
      <button
        class="btn btn-danger"
        type="button"
        :disabled="!orders?.filter((o) => o.selected).length"
        @click="deleteSelectedOrdersAsync"
      >
        Izbriši izbrane
      </button>
    </div>
  </div>
  <Paging v-if="orders?.length" :paging="paging" @change="setPageNum" />
</template>

<script setup>
/* global VueRouter */
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { setError, setSuccess, startLoading, stopLoading } from "../components/Notification"
import { useWorkOrders } from "../composition-api/useWorkOrders"
import { useEnums } from "../composition-api/useEnums"
import SearchMaterial from "scripts/components/SearchMaterial.vue"
import PeriodicsFilter from "../components/PeriodicsFilter.vue"
import { patchWorkOrderAsync } from "../api"
import {
  useAuth,
  authState,
  isAuthenticated,
  user,
  role,
  isAdmin,
  showMessageToWorker,
  currentWorkerId,
  currentCustomerId,
} from "../composition-api/useAuth"
import { useWorker } from "../composition-api/useWorker"
import { hasRoleStartsWith } from "scripts/utils/roles"
import ModalAssignWorkOrderSimple from "../components/ModalAssignWorkOrderSimple.vue"

defineOptions({ name: "Service" })

const { fetchAuthAsync } = useAuth()
const { worker } = useWorker()

const getDefaultFilters = () => {
  if (hasRoleStartsWith(role.value, ["Worker"])) {
    console.log("Default filters for worker", currentWorkerId.value)
    return {
      ownerID: currentWorkerId.value,
      status: "Active,Accepted,InProgress",
    }
  } else {
    return {
      ownerID: currentWorkerId.value,
      status: "Active,Accepted,InProgress,Triage",
    }
  }
}

const {
  paging,
  resetPaging,
  setPageNum,
  filters,
  sortBy,
  orders,
  downloadAttachmentsAsync,
  resetFilters,
  applyQueryParams,
  selectOrderAsync,
} = useWorkOrders("Service", getDefaultFilters, { syncQueryParams: true })
const { statuses, loadEnumsAsync } = useEnums()

const deleteSelectedOrdersAsync = async (id) => {
  const selectedOrders = orders.value.filter((o) => o.selected)
  startLoading("deleteSelectedOrdersAsync")
  try {
    const result = await Promise.all(
      selectedOrders.map((o) => patchWorkOrderAsync(fetchAuthAsync, { status: "Deleted" }, "Service", o.id)),
    )
    setSuccess({ message: `Izbrisano: ${result.filter((r) => r === true).length}.` })
  } catch (error) {
    setError(error)
  } finally {
    stopLoading("deleteSelectedOrdersAsync")
    resetPaging()
  }
}

const orderToAssign = ref(null)

const onAssigned = () => {
  orderToAssign.value = null
  resetPaging()
}

onMounted(async () => {
  startLoading("Orders")
  try {
    await loadEnumsAsync()
    resetFilters()
    applyQueryParams()
    resetPaging()
    sortBy.value = "DateCreated DESC"
  } catch (e) {
    setError(e)
  }
  stopLoading("Orders")
})
</script>
